export default "__VITE_ASSET__5k3lG80Y__"